import { render, staticRenderFns } from "./ProducerProductDetails.vue?vue&type=template&id=4c990029&scoped=true&"
import script from "./ProducerProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProducerProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProducerProductDetails.vue?vue&type=style&index=0&id=4c990029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c990029",
  null
  
)

export default component.exports